module.exports = __webpack_public_path__ + "media/images/real-last-5-02c479d269520ba1a32329b1c0f35772.png";